import { render, staticRenderFns } from "./LandingBabyRegistryEN.vue?vue&type=template&id=37d7e1ca&scoped=true"
import script from "./LandingBabyRegistryEN.vue?vue&type=script&lang=js"
export * from "./LandingBabyRegistryEN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d7e1ca",
  null
  
)

export default component.exports